import { MetadataContent } from '@jutro/legacy/uiconfig';
import React, { useCallback, useContext, useEffect, useState } from 'react';
import { withRouter } from 'react-router-dom';
import metadata from './DeactivateUser.metadata.json5';
import styles from './DeactivateUser.module.scss'
import PropTypes from 'prop-types';
import { useDataRefresh,
    ViewModelForm,
    ViewModelServiceContext,
} from '@xengage/gw-portals-viewmodel-react';
import { useAuthentication, withAuthenticationContext } from '@xengage/gw-digital-auth-react';
import { AgencyAdminService } from '../../../../capabilities/twia-capability-agencyadmin';
import { useValidation } from '@xengage/gw-portals-validation-react';
import messages from './DeactivateUser.messages';
import _ from 'lodash';
import { useModal } from '@jutro/components';

function DeactivateUser(props) {
    const {
        history,
        id,
        userData,
        userActionFlag
    } = props;
    const { onValidate, isComponentValid, registerComponentValidation } = useValidation('DeactivateUser');
    const viewModelService = useContext(ViewModelServiceContext);
    const { authHeader } = useAuthentication();
    const [deactivateVM, setDeactivateVM]  = useState();
    const { refreshData } = useDataRefresh();
    const { showAlert } = useModal();
    const [showErrors, setShowErrors] = useState(false);
    useEffect(() => {
        AgencyAdminService.loadUserByPublicID(userData.publicID.value, authHeader).then((res) => {  
            setDeactivateVM(res);
        }, (err) => {
        });
    },[]);

    useCallback(() => {
        if (onValidate) {
          onValidate(isComponentValid, id);
        }
      }, [id, isComponentValid, onValidate]);


    const writeValue = useCallback(
        (value, path) => {
            _.set(deactivateVM, 'reason_EXT', value);
            if (userActionFlag === 'deactivate') {
                _.set(deactivateVM, 'deactivateUser_EXT', true);
                _.set(deactivateVM, 'status', false);
            } else {
                _.set(deactivateVM, 'deactivateUser_EXT', false);
                _.set(deactivateVM, 'status', true);
            }
            setDeactivateVM(deactivateVM);
            refreshData();
        },
        [deactivateVM, refreshData]
    );

    const cancel = useCallback(() => {
        history.go('/administration');
    })

    const submit = useCallback(() => {
        if (!isComponentValid) {
            setShowErrors(true);
            return false;
        }

        if (userActionFlag === 'deactivate') {
            AgencyAdminService.deactivateUser(deactivateVM, authHeader).then((res) => {    
                history.go('/administration');
            }, (err) => {
                const errorCode = _.get(err, 'data.appErrorCode');
                if (errorCode === 5240) { 
                    showAlert({
                        title: messages.userSaveFailed,
                        message: messages.userSaveFailedMessage,
                        status: 'error',
                        icon: 'mi-error-outline',
                        confirmButtonText: messages.ok,
                    }).then(() => {
                        history.go('/administration'); 
                    }, _.noop);
                } else {
                    showAlert({
                        title: messages.userSaveFailed,
                        message: messages.savedFailed,
                        status: 'error',
                        icon: 'mi-error-outline',
                        confirmButtonText: messages.ok,
                    }).then(() => {
                        history.go('/administration'); 
                    }, _.noop);
                }
            });
        } else if (userActionFlag === 'activate') {
            AgencyAdminService.activateUser(deactivateVM, authHeader).then((res) => {   
                history.go('/administration'); 
            }, (err) => {
            });
        }
         
    })
    
    const overrideProps = {
        '@field': {
            labelPosition: 'left',
            showErrors,
            phoneWide: {
                labelPosition: 'top',
            },
        },
        submitButton:{
            //disabled:!isComponentValid
        },
        addDeactivateLabel: {
            visible: userActionFlag === 'deactivate'
        },
        addActivateLabel: {
            visible: userActionFlag === 'activate'
        }
    };
    const resolvers = {
        resolveClassNameMap: styles,
        resolveCallbackMap: {
            clickCancel: cancel,
            clickSubmit: submit
        }
    };

    return (
        <ViewModelForm
                uiProps={metadata.pageContent}
                model={deactivateVM}
                overrideProps={overrideProps}              
                classNameMap={resolvers.resolveClassNameMap}
                componentMap={resolvers.resolveComponentMap}
                callbackMap={resolvers.resolveCallbackMap}
                onValueChange={writeValue}
                onValidationChange={onValidate}
                />
        );
}

DeactivateUser.propTypes = {  
    history: PropTypes.shape({
        push: PropTypes.func,
    }).isRequired,
    authHeader: PropTypes.shape({}).isRequired
};

export default withAuthenticationContext(withRouter(DeactivateUser));
